
import { type ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

type Role = 'customer' | 'provider' | 'admin';

interface ProtectedRouteProps {
  
  children?: ReactNode;
 
  requiredRole?: Role;

  redirectTo?: string;
}

function getRoleHome(role?: string) {
  switch (role) {
    case 'customer':
      return '/customer/dashboard';
    case 'provider':
      return '/provider/dashboard';
    case 'admin':
      return '/admin/dashboard';
    default:
      return '/';
  }
}

export function ProtectedRoute({ children, requiredRole, redirectTo = '/auth/login' }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-6 h-6 text-primary-500 animate-spin" />
          <p className="text-sm text-gray-500">Checking your session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to={getRoleHome(user?.role)} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}